/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./help-bottom";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
import * as i4 from "../../../globals";
var styles_HelpBottomPage = [];
var RenderType_HelpBottomPage = i0.ɵcrt({ encapsulation: 2, styles: styles_HelpBottomPage, data: {} });
export { RenderType_HelpBottomPage as RenderType_HelpBottomPage };
export function View_HelpBottomPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "div", [["class", "btn-help"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.openHelp() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i0.ɵeld(1, 0, null, null, 0, "i", [["class", "mdi mdi-headset icon-help"]], null, null, null, null, null))], null, null); }
export function View_HelpBottomPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "comp-help-bottom", [], null, null, null, View_HelpBottomPage_0, RenderType_HelpBottomPage)), i0.ɵdid(1, 49152, null, 0, i1.HelpBottomPage, [i2.NavController, i3.NavParams, i4.Globals], null, null)], null, null); }
var HelpBottomPageNgFactory = i0.ɵccf("comp-help-bottom", i1.HelpBottomPage, View_HelpBottomPage_Host_0, {}, {}, []);
export { HelpBottomPageNgFactory as HelpBottomPageNgFactory };
//# sourceMappingURL=help-bottom.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/help-bottom/help-bottom.ngfactory.js
// module id = null
// module chunks = 